import script from "./chooseImg.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseImg.vue?vue&type=script&setup=true&lang=js"

import "./chooseImg.vue?vue&type=style&index=0&id=1af20d43&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af20d43"]])

export default __exports__